import type { RefObject } from "react";

export function scrollToElement(id: string, animate?: boolean, center?: boolean) {
    const element = document.getElementById(id);

    if (element) {
        element.scrollIntoView({
            behavior: animate ? "smooth" : "instant",
            ...(center ? { block: "center", inline: "center" } : {}),
        });
    }
}

export function scrollRefToBottom(
    ref: RefObject<HTMLDivElement | null>,
    animate?: boolean,
) {
    if (ref.current) {
        ref.current.scrollTo({
            top: ref.current.scrollHeight,
            behavior: animate ? "smooth" : "instant",
        });
    }
}
